export const getZPLCommandWithCustomTemplate = (templateProperties, customTemplate) => {
  return new Function(`return \`${customTemplate}\`;`).call(templateProperties);
};
